import { tv } from 'tailwind-variants';

//component variants
export const loyaltyTermsOfUseTailwindVariant = tv(
  {
    slots: {
      base: 'flex flex-col',
      title: 'font-primary',
      buttonWrapper: 'flex',
      buttonCover: 'flex',
      button:
        'flex justify-center items-center hover:no-underline font-heading-desk-medium-bold leading-heading-desk-medium-bold text-heading-desk-medium-bold text-color-text-white flex',
      agreeText:
        'text-body-large-bold font-body-large-bold font-primary leading-body-large-bold w-fit',
      description:
        '[&_a]:text-color-text-brand-1 [&_a]:underline hover:[&_a]:text-color-brand-tertiary-3-base focus:[&_a]:text-color-brand-tertiary-3-base overflow-y-auto font-primary border-[1px] border-color-border-dark text-body-large-regular font-body-large-regular leading-body-large-regular flex flex-col',
      ctaLink: [
        'text-color-text-brand-1',
        'text-heading-desk-medium-bold',
        'font-heading-desk-medium-bold',
        'leading-heading-desk-medium-bold',
        'underline cursor-pointer',
      ],
      popUpWrapper: ['flex-col', 'gap-desk-space-between-tight-vertical'],
      popUpWidth: [
        'max-w-[995px]',
        'pl-mob-padding-base-x',
        'max-w-[995px]',
        'pl-mob-padding-base-x',
      ],
      popUpTitle: [
        'font-heading-desk-large-bold',
        'text-heading-desk-large-bold',
        'leading-heading-desk-large-bold',
      ],
      popUpDescription: [
        'font-body-large-regular',
        'text-body-large-regular',
        'leading-body-large-regular',
      ],
      popUpCTAWrapper: ['gap-[8px]', 'align-start', 'mt-desk-margin-base-top'],
      gotItCTA:
        'text-heading-mob-large-bold lg:text-heading-desk-large-bold font-heading-mob-large-bold lg:font-heading-desk-large-bold leading-heading-mob-large-bold lg:leading-heading-desk-large-bold py-desk-component-button-full-padding-y px-desk-component-button-full-padding-x lg:px-desk-component-button-full-padding-x hover:no-underline cursor-pointer bg-color-text-brand-Large hover:bg-color-brand-primary-1-dark text-color-text-white text-center',
    },
    compoundSlots: [{ slots: ['popUpWrapper', 'popUpCTAWrapper'], className: 'flex' }],
    variants: {
      size: {
        mobile: {
          base: 'gap-mob-padding-loose-bottom px-mob-global-grid-margin',
          title:
            'font-heading-mob-xLarge-bold text-heading-mob-xLarge-bold leading-heading-mob-xLarge-bold',
          description: 'max-h-[387px] px-mob-padding-micro-y py-mob-padding-micro-x',
          buttonWrapper:
            'flex-col mt-desk-global-spacing-spacing-6 gap-mob-global-spacing-spacing-6',
          buttonCover: 'flex-col gap-mob-global-spacing-spacing-6 mb-mob-padding-loose-bottom',
          button:
            'rounded-mob-global-radius-small px-mob-component-button-full-padding-x py-mob-component-button-full-padding-y',
          ctaLink: 'ml-auto mr-auto',
          popUpCTAs: ['!px-0', 'max-w-[140px]'],
          gotItCTA: ['w-full'],
        },
        desktop: {
          base: 'gap-desk-padding-tight-bottom px-0',
          buttonWrapper: 'mt-desk-global-spacing-spacing-5 gap-desk-global-spacing-spacing-5',
          buttonCover: 'flex-row items-center gap-desk-global-spacing-spacing-5',
          title:
            'font-heading-desk-xLarge-bold text-heading-desk-xLarge-bold leading-heading-desk-xLarge-bold',
          description: 'max-h-[295px] px-desk-padding-micro-x py-desk-padding-micro-y ',
          ctaLink: 'm-0',
          button:
            'mb-0 w-fit rounded-desk-global-radius-small px-desk-component-button-full-padding-x py-desk-component-button-full-padding-y',
          popUpCTAs: ['!px-desk-component-button-full-padding-x', 'max-w-none', 'w-fit'],
          gotItCTA: ['w-fit'],
        },
      },
      buttonDisabled: {
        true: {
          button: 'focus:outline-none bg-color-brand-primary-1-disabled cursor-not-allowed',
        },
        false: {
          button:
            'bg-color-brand-primary-1-base cursor-pointer hover:bg-color-brand-primary-1-dark focus:bg-color-brand-primary-1-dark',
        },
      },
    },
  },
  { responsiveVariants: ['lg'] }
);
